import Vue from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';

Vue.component('VueEasyLightbox', VueEasyLightbox);
